import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { space, layout, buttonStyle, borderRadius, } from 'styled-system';
import { Spinner } from '../spinner/spinner';
import styled from '../../styles/styled';
import { ButtonAppText } from '../typography/app_text';
const StyledButton = styled.button(props => ({
    border: 'none',
    cursor: 'pointer',
    height: props.mobile ? '48px' : '40px',
    borderRadius: props.mobile ? '24px' : '20px',
    textAlign: 'center',
    textDecoration: 'none',
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '40px',
    paddingRight: '40px',
    ':focus:not(.focus-visible)': {
        outline: 'none',
    },
    ':disabled': {
        cursor: 'not-allowed',
    },
}), layout, space, borderRadius, buttonStyle);
export const Button = ({ loading, children, fontSize, variant = 'primary', fontColor, light, type = 'button', ...rest }) => {
    return (_jsx(StyledButton, { variant: variant, type: type, ...rest, children: typeof children === 'function' ? (
        // @ts-expect-error - TODO: fix the typing
        children({ loading })) : loading ? (_jsx(Spinner, { size: "30px", color: variant === 'secondary' ? 'black' : 'white' })) : (_jsx(ButtonAppText, { headingFontFamily: true, semibold: true, color: fontColor ? fontColor : 'inherit', size: fontSize, light: light, children: children })) }));
};
export default Button;
//# sourceMappingURL=button.js.map